const EVENT_TYPES = {
  UPDATE: 'UPDATE',
  SAVE: 'SAVE',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  CREATE_EXPORTED_DICTIONARY_WORD: 'CREATE_EXPORTED_DICTIONARY_WORD',
}

export default EVENT_TYPES
